import { IGameIdentityGoal } from "motw_core/Entity/IGameIdentityGoal";
import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import {
    GetGoalIconName,
    GetGoalName,
} from "source/app/presentation/MainPanel/GameIdentities/ShowIdentity/IdentityGoals/IdentityGoalNames";
import { GoalIcon } from "source/app/presentation/MainPanel/GameIdentities/ShowIdentity/IdentityGoals/Name/Icon/GoalIcon";
import { Style } from "source/app/presentation/Shared/Styles/CSS";
import { IGameIdentityDTO } from "../../../../../../../../../motw_core/DTOs/IGameIdentityDTO";
import { DeleteGoalLink } from "../../DeleteGoalLink/DeleteGoalLink";
import { GoalName } from "../../../../Goals/GoalCards/Show/Contents/Body/GoalName/GoalName";
import { GoalWeeklyRateAmount } from "source/app/presentation/MainPanel/GameIdentities/ShowIdentity/IdentityGoals/Name/WeeklyRateAmount/GoalWeeklyRateAmount";

export function IdentityGoalName({
    allGoals,
    gameIdentityGoal,
    goalNamesLoggedToday,
    identity,
}: {
    allGoals: IGoal[];
    gameIdentityGoal: IGameIdentityGoal;
    goalNamesLoggedToday: string[];
    identity: IGameIdentityDTO;
}) {
    const goalName = GetGoalName(allGoals, gameIdentityGoal);
    const goalIconName = GetGoalIconName(allGoals, gameIdentityGoal);
    const isLoggedToday = goalNamesLoggedToday.includes(goalName);

    return (
        <span
            {...Style(`identityGoalNames_${isLoggedToday}`, {
                position: "relative",
                background: isLoggedToday
                    ? `hsla(82, 100%, 25.1%, 0.48)`
                    : "hsla(0, 0%, 0%, 0.15)",
                borderRadius: "4px",
                display: "inline-block",
                margin: "1px 3px",
                padding: "4px",
                transition: `all 2s`,
                ":hover": {
                    background: `hsla(69, 100%, 60%, 0.05)`,
                },
            })}
        >
            <span
                {...Style(`identityGoalNameText`, {
                    marginLeft: `5px`,
                })}
            >
                <GoalIcon iconName={goalIconName} />
                {LimitNameLength(goalName)}
            </span>
            <DeleteGoalLink
                allGoals={allGoals}
                gameIdentityGoal={gameIdentityGoal}
                identity={identity}
                goalNamesLoggedToday={goalNamesLoggedToday}
            />
            <GoalWeeklyRateAmount {...{ allGoals, goalName }} />
        </span>
    );
}

function LimitNameLength(name: string) {
    const maxNameLength = 12;

    if (name.length <= maxNameLength) {
        return name;
    }

    return name.slice(0, maxNameLength) + "...";
}

